export default {
  formModal: false,
  accessModal: false,
  hasInitialData: false,
  drawer: false,
};
